'use strict';

(function (angular) {
    // initialize store finder angular app
    // bootstrap app manually as only the first app on a page can be initialized by data-ng-app (which is the framework/header)
    angular.bootstrap(document.getElementById('jwsdw-storeFinder'), ['jwsdw.storeFinder']);
}(angular));